import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_68: FaireProductEntity = {
  token: "catalog_prod_prod-68",
  type: "product",
  name: "Black Mango Wood Milking Stool - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 98.09,
  msrpDollars: 245.23,
  sku: "JA0068",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 325,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
